import { deleteJson, getJson, postJson } from './client'
import type { NotesView } from '../types/notes'
import type { JobView } from '../types/voice'

// The OneNote connector (REQ-107): connect a person's own OneNote under a consent of its own; every read of it is
// the notes-sync job. Nothing here touches the mailbox connection.
const notes = (spoke: string) => `/api/spokes/${encodeURIComponent(spoke)}/scout/notes`

export const notesApi = {
  view: (spoke: string) => getJson<NotesView>(notes(spoke)),
  connect: (spoke: string) => postJson<{ authorizeUrl: string; state: string }>(`${notes(spoke)}/connect`, {}),
  sync: (spoke: string) => postJson<JobView>(`${notes(spoke)}/sync`, {}),
  disconnect: (spoke: string) => deleteJson<void>(notes(spoke)),
}
